import React from "react";
import "./StarRating.css";

function StarRating({ score = 0 }) {
    const getStar = (index) => {
        if (score <= 35) return index === 0 ? "fas fa-star" : "far fa-star";
        if (score <= 70) return index < 2 ? "fas fa-star" : "far fa-star";
        return "fas fa-star";
    };

    return (
        <div className="star-rating">
            <i className={getStar(0)}></i>
            <i className={getStar(1)}></i>
            <i className={getStar(2)}></i>
            <span className="star-rating__score">{score}/100</span>
        </div>
    );
}

export default StarRating;